import MagaluService, { isSuccess } from '@magalu/webzord';
export var useGetUserLocation = function (update, logger) {
    if (logger === void 0) { logger = console; }
    return new Promise(function (resolve, reject) {
        try {
            MagaluService.request({
                serviceName: 'customer.getCustomerLocation',
                serviceArgs: {
                    update_required: update, // open native bottom sheet
                },
                callbackId: 'get-user-location',
                callback: function (result) {
                    if (isSuccess(result)) {
                        resolve(result.body);
                    }
                    else {
                        logger.error('[useGetUserLocation] - error', result);
                        reject(result);
                    }
                },
            });
        }
        catch (error) {
            logger.error('[useGetUserLocation] - error - catch', error);
            reject(error);
        }
    });
};
